import type { VisitorsFeedEvent } from '@utils/visitorsActiveNow'

const CHANNEL_NAME = 'chatx.visitors.feed.v1'

export type VisitorsTabSyncMessage = {
  type: 'visitors.feed'
  at: number
  event: VisitorsFeedEvent
}

function canUseBroadcastChannel(): boolean {
  return typeof window !== 'undefined' && typeof BroadcastChannel !== 'undefined'
}

let channel: BroadcastChannel | null = null

function getChannel(): BroadcastChannel | null {
  if (!canUseBroadcastChannel()) return null
  if (channel) return channel
  try {
    channel = new BroadcastChannel(CHANNEL_NAME)
  } catch {
    channel = null
  }
  return channel
}

/** Push a visitors.feed event to other operator browser tabs. Same tab is not notified. */
export function publishVisitorsFeedToOtherTabs(event: VisitorsFeedEvent): void {
  const ch = getChannel()
  if (!ch) return
  const message: VisitorsTabSyncMessage = {
    type: 'visitors.feed',
    at: Date.now(),
    event,
  }
  try {
    ch.postMessage(message)
  } catch {
    /* ignore */
  }
}

export function subscribeVisitorsFeedFromOtherTabs(
  onEvent: (event: VisitorsFeedEvent) => void,
): () => void {
  const ch = getChannel()
  if (!ch) return () => {}

  const onMessage = (ev: MessageEvent<VisitorsTabSyncMessage>) => {
    const data = ev.data
    if (!data || data.type !== 'visitors.feed' || !data.event) return
    onEvent(data.event)
  }
  ch.addEventListener('message', onMessage)
  return () => {
    ch.removeEventListener('message', onMessage)
  }
}
